import React, { useContext } from 'react';
import {
  CommunicationsProviderProps,
  ICommunicationsContext,
} from './interfaces';
import { env } from 'env';

const { REACT_APP_FEATURE_THIRD_PARTY_COMMUNICATIONS_PROVIDER } = env;
let useHookLib: () => ICommunicationsContext;
switch (REACT_APP_FEATURE_THIRD_PARTY_COMMUNICATIONS_PROVIDER) {
  case 'ZOOM':
    useHookLib = require('@features/zoom/hooks/useZoom').default;
    break;
  default:
    throw new Error(
      `Unknown library: ${REACT_APP_FEATURE_THIRD_PARTY_COMMUNICATIONS_PROVIDER}`,
    );
}

export const CommunicationsContext =
  React.createContext<ICommunicationsContext>({} as ICommunicationsContext);

export const useCommunications = () => useContext(CommunicationsContext);

export const CommunicationsProvider: React.FC<CommunicationsProviderProps> = ({
  children,
}) => {
  const valuesFromThirdPartyHook = useHookLib?.();

  return (
    <CommunicationsContext.Provider value={valuesFromThirdPartyHook}>
      {children}
    </CommunicationsContext.Provider>
  );
};
